export const DEFAULT_REVIEW_DEADLINE_DAYS = 5;

export enum ReviewDeadlineState {
  ON_TRACK = "On track",
  DUE_SOON = "Due soon",
  DUE_TODAY = "Due today",
}

const DUE_SOON_MAX_DAYS = 2;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

const startOfDay = (date: Date): Date => new Date(date.getFullYear(), date.getMonth(), date.getDate());

export const daysElapsed = (createdDate: Date, today: Date): number =>
  Math.max(Math.round((startOfDay(today).getTime() - startOfDay(createdDate).getTime()) / MS_PER_DAY), 0);

export const daysRemaining = (createdDate: Date, deadlineDays: number, today: Date): number =>
  Math.max(deadlineDays - daysElapsed(createdDate, today), 0);

export const getReviewDeadlineState = (daysLeft: number): ReviewDeadlineState => {
  if (daysLeft <= 0) {
    return ReviewDeadlineState.DUE_TODAY;
  }
  return daysLeft <= DUE_SOON_MAX_DAYS ? ReviewDeadlineState.DUE_SOON : ReviewDeadlineState.ON_TRACK;
};
